import {WeekDay} from 'enums';
import {WorkingHours as WorkingHoursType} from 'types';

export const FIELDS = {
    WEEK_HOURS: 'weekHours',
    SPECIAL_HOURS: 'specialHours',
    NEW_SPECIAL_HOURS_ITEM: 'newSpecialItem',
    INTERVALS: 'intervals'
};

export const EMPTY_VALUE: WorkingHoursType = {
    enabled: false,
    weekHours: {
        [WeekDay.Monday]: {intervals: []},
        [WeekDay.Tuesday]: {intervals: []},
        [WeekDay.Wednesday]: {intervals: []},
        [WeekDay.Thursday]: {intervals: []},
        [WeekDay.Friday]: {intervals: []},
        [WeekDay.Saturday]: {intervals: []},
        [WeekDay.Sunday]: {intervals: []}
    },
    specialHours: []
};